import { Component, OnInit, HostListener, OnDestroy, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { WpapiService } from 'src/app/services/wpapi.service';
import { socialFade, workAnimation } from 'src/app/animations/animation';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from "rxjs";
import { throttleTime } from 'rxjs/operators';
import { PageService } from 'src/app/services/page.service';
import { SeoService } from 'src/app/services/seo.service';

export enum KEY_CODE {
    UP_ARROW = 38,
    DOWN_ARROW = 40
}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    animations: [workAnimation, socialFade],
})
export class HomeComponent implements OnInit {

    counter: number = 0;
    screenHeight: number;
    scrollHeight: number;
    activeGrid: boolean = false;
    menuActive: boolean = false;
    isMac = navigator.platform;
    is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    screenWidth: number;
    home: any;
    instagram: any;
    dangeroushtml: any;
    dangeroushtmlchecked: any;
    counterposition: number = 0;
    private SubjectUp = new Subject<number>();
    private SubjectDown = new Subject<number>();
    private SubjectUpMac = new Subject<number>();
    private SubjectDownMac = new Subject<number>();
    lastScrollTop = 0;
    isScrolling;
    mobileScrolling: number = 0;
    touchdirection: number = 0;
    touchstart: number = 0;
    direction: string = '';
    active = false;
    currentY;
    initialY;
    yOffset = 0;
    stopScrollAnimation: boolean = false;
    bottomStop: boolean = true;
    topStop: boolean = false;
    swiped: boolean = false;
    activateMenuOverlay: boolean = false;
    isActivated: boolean = false;
    isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth > 1024) {
            this.screenHeight = document.getElementById('main-container-wrapper').clientHeight - 10;
            this.scrollHeight = 6 * (this.screenHeight);
            this.counter = 0;
        } else {
            this.screenHeight = window.innerHeight;
        }
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (this.screenWidth > 1024) {
            if (event.keyCode === KEY_CODE.UP_ARROW) {
                this.onScrollUp();
            }
            if (event.keyCode === KEY_CODE.DOWN_ARROW) {
                this.onScrollDown();
            }
        }
    }

    constructor(private wpApi: WpapiService,
        private sanitizer: DomSanitizer,
        private pageService: PageService,
        private seoService: SeoService) {

        this.pageService.listen().subscribe((m: boolean) => {
            this.onMenuActive(m);
        })

        this.pageService.goToTopListen().subscribe(() => {
            if (this.isIPadPro && this.screenWidth > 1024) {
                const grid = document.getElementById('main-container-wrapper');
                grid.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                this.counter = 0;
            }
        })

        this.pageService.activateMenuOverlayListen().subscribe((resp) => {
            this.activateMenuOverlay = resp;
        })
    }

    onMenuActive(m) {
        this.menuActive = m;
    }

    ngOnInit() {
        this.onResize();
        window.scrollTo(0, 0);
        this.counter = 0;
        this.getHomePage();
        if (this.screenWidth > 1024) {
            this.scrollHeight = 6 * (this.screenHeight);
        } else {
            this.scrollHeight = 7 * (this.screenHeight);
        }
        this.SubjectUp.asObservable()
            .pipe(
                throttleTime(200)
            ).subscribe(x => this.doSomethingWithThrottledEventUp(x));
        this.SubjectDown.asObservable()
            .pipe(
                throttleTime(200)
            ).subscribe(x => this.doSomethingWithThrottledEventDown(x));
        this.SubjectUpMac.asObservable()
            .pipe(
                throttleTime(500)
            ).subscribe(x => this.doSomethingWithThrottledEventUpMac(x));
        this.SubjectDownMac.asObservable()
            .pipe(
                throttleTime(500)
            ).subscribe(x => this.doSomethingWithThrottledEventDownMac(x));
    }

    getHomePage() {
        this.wpApi.getHome().subscribe(resp => {
            this.handleResponse(resp);
        })
    }

    handleResponse(resp) {
        this.home = resp[0].acf;
        this.seoService.setSeoMetaTags(resp[0]);
        this.dangeroushtml = this.home.instagram;
        this.dangeroushtmlchecked = this.sanitizer.bypassSecurityTrustHtml(this.dangeroushtml);
        this.instagram = new DOMParser().parseFromString(this.dangeroushtmlchecked.changingThisBreaksApplicationSecurity, "text/html");
    }

    handleInstagramResponse(resp) {
        this.dangeroushtml = resp[0].content.rendered;
        this.dangeroushtmlchecked = this.sanitizer.bypassSecurityTrustHtml(this.dangeroushtml);
        this.instagram = new DOMParser().parseFromString(this.dangeroushtmlchecked.changingThisBreaksApplicationSecurity, "text/html");
    }

    mouseWheelUpFunc(event) {
        event.preventDefault();
        if (this.screenWidth > 1024) {
            if (!(/iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent))) {
                if (this.isMac == 'MacIntel' || this.isMac == 'Mac68K' || this.isMac == 'MacPPC') {
                    if (event.wheelDelta != undefined && event.wheelDelta > 80) {
                        this.SubjectUpMac.next(event);
                    }
                    if (event.detail < -2) {
                        this.SubjectUpMac.next(event);
                    }
                } else {
                    if (event.wheelDelta != undefined && event.wheelDelta > 80) {
                        this.SubjectUp.next(event);
                    }
                    if (event.detail < -2) {
                        this.SubjectUp.next(event);
                    }
                }
            }
        }
    }

    mouseWheelDownFunc(event) {
        event.preventDefault();
        if (this.screenWidth > 1024) {
            if (!(/iPhone|iPad|iPod|Android|webOS|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent))) {
                if (this.isMac == 'MacIntel' || this.isMac == 'Mac68K' || this.isMac == 'MacPPC') {
                    if (event.wheelDelta != undefined && event.wheelDelta < -80) {
                        this.SubjectDownMac.next(event);
                    }
                    if (event.detail > 2) {
                        this.SubjectDownMac.next(event);
                    }
                } else {
                    if (event.wheelDelta != undefined && event.wheelDelta < -80) {
                        this.SubjectDown.next(event);
                    }
                    if (event.detail > 2) {
                        this.SubjectDown.next(event);
                    }
                }
            }
        }
    }

    private doSomethingWithThrottledEventUp(event: any) { this.onScrollUp(); }
    private doSomethingWithThrottledEventUpMac(event: any) { this.onScrollUp(); }
    private doSomethingWithThrottledEventDown(event: any) { this.onScrollDown(); }
    private doSomethingWithThrottledEventDownMac(event: any) { this.onScrollDown(); }

    onScrollUp() {
        if (this.counter < 0) {
            this.counter += (this.screenHeight);
            this.counterposition = this.counter;
            this.pageService.rotateLeftLogo();
        }
        if (this.counter > 0) {
            this.counter = 0;
            this.pageService.rotateLeftLogo();
        }
    }

    onScrollDown() {
        this.counter -= (this.screenHeight);
        this.counterposition = this.counter;
        if (this.counter < -(this.scrollHeight - this.screenHeight)) {
            this.counter = -(this.scrollHeight - this.screenHeight);
        } else {
            this.pageService.rotateRightLogo();
        }
        if (-(this.counter) > 0 && -(this.counter) == this.screenHeight) {
            this.pageService.scrolled(true);
        }
    }
}

